import { render, staticRenderFns } from "./LocaleMenu.vue?vue&type=template&id=53ecf733&"
import script from "./LocaleMenu.vue?vue&type=script&lang=ts&"
export * from "./LocaleMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports